export default "__VITE_ASSET__AxitG4nE__"